import React, { useEffect, useRef, useState } from 'react';
import '../App.css';
import './footer.css';
import { FaFacebook, FaInstagram, FaLinkedin, FaGoogle, FaYelp } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ReactCurvedText from "react-curved-text";
import { PiPhoneCallBold } from "react-icons/pi";
import { Ri24HoursLine } from "react-icons/ri";
import { Nav, NavLink, NavMenu }
	from "../components/NavbarElements";

const useFooter = () => {
  const getCurrentYear = () => new Date().getFullYear();
  return { currentYear: getCurrentYear() };
};

const Footer = () => {
  const { currentYear } = useFooter();
  const [isVisible, setIsVisible] = useState(false);
  const footerDivRef = useRef(null);
  const footerRef = useRef(null);
  const canvasRef = useRef(null);

  const handleScroll = () => {
    if (footerDivRef.current) {
      const elementTop = footerDivRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      const triggerOffset = 100;
      if (elementTop < windowHeight - triggerOffset) {
        setIsVisible(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const footer = footerRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let leavesArray = [];

    canvas.width = footer.offsetWidth;
    canvas.height = footer.offsetHeight;

    window.addEventListener('resize', () => {
      canvas.width = footer.offsetWidth;
      canvas.height = footer.offsetHeight;
    });

    const createLeaf = (x, y) => {
      const leaf = {
        x,
        y,
        size: Math.random() * 15 + 5,
        speedX: Math.random() * 2 - 1,
        speedY: Math.random() * 1 + 1,
        rotation: Math.random() * 360,
        rotationSpeed: Math.random() * 2 - 1,
        alpha: 1,
      };
      leavesArray.push(leaf);
    };

    const handleMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      for (let i = 0; i < 3; i++) {
        createLeaf(mouseX, mouseY);
      }
    };

    const handleTouchMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const touch = e.touches[0];
      const mouseX = touch.clientX - rect.left;
      const mouseY = touch.clientY - rect.top;
      for (let i = 0; i < 3; i++) {
        createLeaf(mouseX, mouseY);
      }
    };

    const updateLeaves = () => {
      for (let i = 0; i < leavesArray.length; i++) {
        const leaf = leavesArray[i];
        leaf.x += leaf.speedX;
        leaf.y += leaf.speedY;
        leaf.rotation += leaf.rotationSpeed;
        leaf.alpha -= 0.003;

        if (leaf.alpha <= 0) {
          leavesArray.splice(i, 1);
          i--;
        }
      }
    };

    const drawLeaves = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (const leaf of leavesArray) {
        ctx.save();
        ctx.translate(leaf.x, leaf.y);
        ctx.rotate((leaf.rotation * Math.PI) / 180);
        ctx.globalAlpha = leaf.alpha;

        ctx.fillStyle = 'rgba(34, 139, 34, 0.8)'; // Leaf green color
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.ellipse(0, 0, leaf.size, leaf.size / 2, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
    };

    const animate = () => {
      updateLeaves();
      drawLeaves();
      requestAnimationFrame(animate);
    };

    footer.addEventListener('mousemove', handleMouseMove);
    footer.addEventListener('touchmove', handleTouchMove);
    footer.addEventListener('touchstart', handleTouchMove);
    animate();

    return () => {
      footer.removeEventListener('mousemove', handleMouseMove);
      footer.removeEventListener('touchmove', handleTouchMove);
      footer.removeEventListener('touchstart', handleTouchMove);
    };
  }, []);

  return (
    <footer id='footer1' ref={footerRef}>
      <canvas ref={canvasRef} id="waterCanvas"></canvas>
      <div id="footerdiv1" className={`slide-in-div-footer ${isVisible ? 'visible' : ''}`} ref={footerDivRef}>
      <div class="text-container2">
            <ReactCurvedText
              width={500}
              height={200}
              cx={250}
              cy={350}
              rx={230}
              ry={230}
              startOffset={180}
              reversed={true}
              text="DANGEROUS TREES ARE OUR SPECIALTY !"
              />
        </div>
        <div id="tengucute_div"></div>
        <div id="yokaifooter_header">
          <div className='emergency_phone_app2' onClick={() => window.location.href = 'tel:941-879-8853'}>
              <div className='circle_icon_emergency_phone_app2'><PiPhoneCallBold /></div>
                <span>24/7 Emergency#</span>
              <div className='circle_icon_emergency_phone_app2'><Ri24HoursLine /></div>
          </div>
        </div>
        <div id='footerdiv2'>
          <p id="softwarelogo"></p>
        </div>
        <div id='footerdiv3'>
          <p>Look for us on these social media platforms</p>
        </div>
        <div id='footerdiv4'>
          <div id='yokaifooter_header2'><h2>Contact Us</h2></div>
          <div id='footer_contactinfo'>
            <p>phone: </p>
            <p>email: </p>
          </div>
        </div>
        <div id='footerdiv5'>
          <Link to="/contact" style={{ textDecoration: 'none' }} onClick={() => window.scrollTo(0, 0)}>
            <motion.div id='href_footer' whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
              Let's Get Started!
            </motion.div>
          </Link>
        </div>
        <div id="social-icons">

          <a href="https://www.google.com/search?client=firefox-b-1-d&sca_esv=437362fb4f2cc4ff&sxsrf=AHTn8zoelIDSBV0ljmaP6DZLIc3Y9QqIBQ:1740343422672&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzfGevUkDKogCpeEx_4Gv0cIZfTHmOI9e08zDG8ULg2eYmbl9Nw5jvWBMMJh68f61K7B2r4CaahtTXGtei1U8qkBT7S5if8ng13fGj40YuGDkIumRNw%3D%3D&q=SAM%E2%80%99S+Tree+Service+Reviews&sa=X&ved=2ahUKEwinlPu71NqLAxXHsoQIHYsKBx8Q0bkNegQIKRAD&biw=1898&bih=875&dpr=1" target="_blank" rel="noopener noreferrer" aria-label="link to google">
            <FaGoogle size={50} className="google" />
          </a>
          <a id='fafacebook' href="https://www.facebook.com/DangerousTrees" target="_blank" rel="noopener noreferrer" aria-label="Link to Facebook">
            <FaFacebook size={50} className="facebook" />
          </a>
          <a href="https://www.instagram.com/sams.tree/" target="_blank" rel="noopener noreferrer" aria-label="Link to instagram">
            <FaInstagram size={50} className="instagram" />
          </a>
          {/*<a href="https://www.linkedin.com/company/yokai-software-and-web-development/about/" target="_blank" rel="noopener noreferrer">
            <FaLinkedin size={50} className="linkedin" />
          </a>*/}
          <a href="https://www.yelp.com/biz/sams-tree-service-sarasota" target="_blank" rel="noopener noreferrer" aria-label="Link to Yelp">
            <FaYelp size={50} className="yelp" />
          </a>
        </div>
        <div id='copyright'>
          <p>Copyright © {currentYear} Sams Tree Service & <a id='href_contact' href="https://yokaisoftware.com/" aria-label="Link to Yokai software">Yokai Software</a></p>
        </div>
        <NavLink to="/admin" id='log-in_link'>
            Admin
        </NavLink>
      </div>
    </footer>
  );
};

export default Footer;

